import axios from "axios";

export const googleSummaryService = async (
  customerId,
  businessUnitId,
  startDate,
  endDate
) => {
  const res = await axios.get(
    `${process.env.VUE_APP_API_BASE_URL_GOOGLE}/adwords/summary/${customerId}/businesses/${businessUnitId}?fromDate=${startDate}&toDate=${endDate}`
  );
  return res.data;
};
